import { jsx as l, jsxs as u } from "react/jsx-runtime";
import { FocusTrapFeatures as d, FocusTrap as y } from "@headlessui/react";
import { ColorPicker as C, Tooltip as A, NeutralButton as E, NeutralTypeEnum as I, PrimaryButton as w } from "@systemeio/ui";
import { useEditorState as L } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as O } from "react";
import { useTranslation as P } from "../../i18n.mjs";
import { twMerge as f } from "tailwind-merge";
import { DEFAULT_COLOR as k, getToolbarIconClassName as h, TOOLBAR_BUTTON_CLASSNAMES as T, getToolbarCaptionClassName as F, TOOLTIP_STYLES as S } from "../../constants/default-styles.mjs";
import b from "../../icons/palette-icon.mjs";
import { normalizeToHex as _ } from "@systemeio/util";
import { isImageSelected as B } from "../image-extension/utils/is-image-selected.mjs";
const Q = (r, g) => {
  const { t: n } = P(), { shouldHideTooltip: m, showAlpha: c = !0 } = g ?? {}, e = L({
    editor: r,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      textColor: o == null ? void 0 : o.getAttributes("textStyle").color,
      isImageSelected: B(o)
    })
  }), i = e == null ? void 0 : e.textColor, s = i ? _(i) : k, t = !!i, a = !(e != null && e.isEditable) || !!(e != null && e.isImageSelected);
  return O(() => {
    const o = (v) => {
      if (!r) return null;
      r.chain().setColor(v).run();
    }, N = () => {
      if (!r) return null;
      r.chain().focus().setColor(s).run();
    }, x = () => {
      if (!r) return null;
      r.chain().focus().unsetColor().run();
    }, p = () => /* @__PURE__ */ l(y, { features: d.None, children: /* @__PURE__ */ u("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ l(
        E,
        {
          className: "w-full",
          neutralType: I.danger,
          disabled: !t,
          onClick: x,
          children: n("global.clear")
        }
      ),
      /* @__PURE__ */ l(w, { className: "w-full", onClick: N, children: n("global.apply") })
    ] }) });
    return {
      toolbarRender: /* @__PURE__ */ l(
        C,
        {
          color: s,
          onChange: o,
          additionalPopoverChildren: p,
          disabled: a,
          showAlpha: c,
          children: () => /* @__PURE__ */ l(
            A,
            {
              disabled: m || a,
              label: n("font_color"),
              ...S,
              children: /* @__PURE__ */ u(
                "div",
                {
                  className: f(
                    T,
                    "main-transition-colors gap-1.5",
                    "relative"
                  ),
                  children: [
                    /* @__PURE__ */ l(b, { className: h(a) }),
                    t && /* @__PURE__ */ l(
                      "div",
                      {
                        className: "absolute bottom-0 h-1 w-4 rounded-lg",
                        style: { backgroundColor: s }
                      }
                    )
                  ]
                }
              )
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ l(
        C,
        {
          focusTrapFeatures: d.FocusLock,
          color: s,
          onChange: o,
          additionalPopoverChildren: p,
          disabled: a,
          showAlpha: c,
          children: () => /* @__PURE__ */ u(
            "div",
            {
              className: f(
                T,
                "gap-1.5",
                "relative",
                "flex gap-1",
                F(a)
              ),
              children: [
                /* @__PURE__ */ l(b, { className: h(a) }),
                n("font_color"),
                t && /* @__PURE__ */ l(
                  "div",
                  {
                    className: "absolute right-0 h-1.5 w-1.5 rounded-full",
                    style: { backgroundColor: s }
                  }
                )
              ]
            }
          )
        }
      )
    };
  }, [s, r, t, a, m, c, n]);
};
export {
  Q as useTextColorExtensionToolbar
};
